var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen",class:`page__${_vm.$route.name}`,attrs:{"id":"app"}},[_c('AppHeader'),_c('div',{staticClass:"flex-grow"},[(_vm.loading)?_c('AppLoader',{attrs:{"modal":""}}):_c('router-view')],1),_c('AppFooter',{attrs:{"mgo-url":_vm.$options.mgoUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }